var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"subreddit":_vm.subreddit}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('Tabs'),_vm._v(" "),(_vm.modifier === _vm.modifiers.CONTROVERSIAL || _vm.modifier === _vm.modifiers.TOP)?_c('div',[_c('ModifierDropdown')],1):_vm._e(),_vm._v(" "),_c('Posts',{attrs:{"modifier":_vm.modifier,"subreddit":_vm.subreddit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-380b53e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subreddit.vue
// module id = 2L46
// module chunks = 1